import { AIProviderConfig } from '@/types/aiProvider';

export const AI_PROVIDERS: Record<string, AIProviderConfig> = {
  openai: {
    name: 'openai',
    displayName: 'OpenAI GPT',
    description: 'Creative and engaging content with excellent formatting',
    models: {
      fast: 'gpt-5-nano-2025-08-07',
      standard: 'gpt-5-mini-2025-08-07',
      premium: 'gpt-5-2025-08-07'
    },
    apiEndpoint: 'https://api.openai.com/v1/chat/completions',
    secretKey: 'OPENAI_API_KEY'
  },
  claude: {
    name: 'claude',
    displayName: 'Claude AI',
    description: 'Thoughtful, nuanced content with superior reasoning',
    models: {
      fast: 'claude-3-5-haiku-20241022',
      standard: 'claude-sonnet-4-20250514',
      premium: 'claude-opus-4-20250514'
    },
    apiEndpoint: 'https://api.anthropic.com/v1/messages',
    secretKey: 'ANTHROPIC_API_KEY'
  },
  gemini: {
    name: 'gemini',
    displayName: 'Google Gemini',
    description: 'Factual, research-heavy content with logical flow',
    models: {
      fast: 'gemini-2.5-flash-lite',
      standard: 'gemini-2.5-flash',
      premium: 'gemini-3-pro-preview'
    },
    apiEndpoint: 'https://generativelanguage.googleapis.com/v1beta/models',
    secretKey: 'GEMINI_API_KEY'
  }
};

export const getProviderConfig = (provider: string) => {
  return AI_PROVIDERS[provider];
};

export const getAllProviders = () => {
  return Object.values(AI_PROVIDERS);
};